import user from './userSlice';
import app from './appSlice';
import authorization from './authorizationSlice';
import tbwAuthorization from './tbwAuthorizationSlice';
import { coachmarksSlice } from '../api/coachmarksSlice';
import { dashboardDataReducer } from './dashBoardReducer';
import { playListDataReducer } from './playListReducer';
import { collectionDataReducer } from './collectionReducer';
import { tbwMetadataReducer } from './tbwMetadataReducer';
import { tbwDashboardDataReducer } from './tbwDashboardDataReducer';
import { tbwSectionDataReducer } from './tbwSectionDataReducer';
import { umDashboardDataReducer } from './umDashboardReducer';
import { tbwInitiateGlobalReducer } from './tbwInitiateGlobalActionReducer';
import tbwAICoAuthorReducer from './tbwAICoAuthorReducer';

export type { dashboardDataReducerInterface } from './dashBoardReducer';
export type { playListDataReducerInterface } from './playListReducer';

const reducers = {
    user,
    app,
    authorization,
    tbwAuthorization,
    dashboardDataReducer,
    playListDataReducer,
    collectionDataReducer,
    tbwMetadataReducer,
    tbwDashboardDataReducer,
    tbwSectionDataReducer,
    umDashboardDataReducer,
    tbwInitiateGlobalReducer,
    tbwAICoAuthor: tbwAICoAuthorReducer,
    [coachmarksSlice.reducerPath]: coachmarksSlice.reducer,
};

export default reducers;
